import pageWhite from 'Images/file-icons/flat/page-white.png';
import pageFolder from 'Images/file-icons/flat/page-folder.png';
import pageWhiteWord from 'Images/file-icons/flat/page-white-word.png';
import pageWhitePowerpoint from 'Images/file-icons/flat/page-white-powerpoint.png';
import pageWhiteAcrobat from 'Images/file-icons/flat/page-white-acrobat.png';
import pageWhiteText from 'Images/file-icons/flat/page-white-text.png';
import pageWhitePicture from 'Images/file-icons/flat/page-white-picture.png';
import pageWhiteSound from 'Images/file-icons/flat/page-white-sound.png';
import pageWhiteFilm from 'Images/file-icons/flat/page-white-film.png';
import pageWhiteCompressed from 'Images/file-icons/flat/page-white-compressed.png';

// Old Microsoft icons
import microsoftVsdx from 'Images/file-icons/microsoft/vsdx_96.svg';
import microsoftVssx from 'Images/file-icons/microsoft/vssx_96.svg';
import microsoftVstx from 'Images/file-icons/microsoft/vstx_96.svg';
import microsoftXltx from 'Images/file-icons/microsoft/xltx_96.svg';

// New Microsoft icons
import microsoftDocx from 'Images/file-icons/microsoft/docx_64.svg';
import microsoftOdt from 'Images/file-icons/microsoft/odt_96.png';
import microsoftDotx from 'Images/file-icons/microsoft/dotx_48.svg';
import microsoftDotm from 'Images/file-icons/microsoft/dotm_96.png';
import microsoftDoc from 'Images/file-icons/microsoft/doc_96.png';
import microsoftPptx from 'Images/file-icons/microsoft/pptx_64.svg';
import microsoftPptm from 'Images/file-icons/microsoft/pptm_96.png';
import microsoftPpt from 'Images/file-icons/microsoft/ppt_96.png';
import microsoftPpsx from 'Images/file-icons/microsoft/ppsx_64.svg';
import microsoftPpsm from 'Images/file-icons/microsoft/ppsm_72.png';
import microsoftPps from 'Images/file-icons/microsoft/pps_96.png';
import microsoftPotx from 'Images/file-icons/microsoft/potx_64.svg';
import microsoftPotm from 'Images/file-icons/microsoft/potm_96.png';
import microsoftPot from 'Images/file-icons/microsoft/pot_96.png';
import microsoftOdp from 'Images/file-icons/microsoft/odp_96.png';
import microsoftXlsx from 'Images/file-icons/microsoft/xlsx_64.svg';
import microsoftXlsm from 'Images/file-icons/microsoft/xlsm_64.svg';
import microsoftXls from 'Images/file-icons/microsoft/xls_96.png';
import microsoftOds from 'Images/file-icons/microsoft/ods_96.png';
import microsoftCsv from 'Images/file-icons/microsoft/csv_96.png';
import microsoftXlsb from 'Images/file-icons/microsoft/xlsb_96.png';

export const getFileSrcAndAlt = (
  filename: string | null | undefined,
  isFolder: boolean | null | undefined,
) => {
  if (!filename) {
    return {
      src: pageWhite,
      alt: 'File',
      extension: 'png',
    };
  }

  if (isFolder) {
    return {
      src: pageFolder,
      alt: 'Folder',
      extension: 'png',
    };
  }

  const raw = filename.split('.');
  const extension = raw[raw.length - 1].toLowerCase();

  switch (extension) {
    case 'doc':
      return {
        src: microsoftDoc,
        alt: 'Microsoft Word file',
        extension: 'png',
      };
    case 'docx':
      return {
        src: microsoftDocx,
        alt: 'Microsoft Word file',
        extension: 'svg',
      };
    case 'docm':
      return {
        src: microsoftDotm,
        alt: 'Microsoft Word macro-enabled file',
        extension: 'png',
      };
    case 'dotx':
      return {
        src: microsoftDotx,
        alt: 'Microsoft Word template file',
        extension: 'svg',
      };
    case 'dotm':
      return {
        src: microsoftDotm,
        alt: 'Microsoft Word macro-enabled template file',
        extension: 'png',
      };
    case 'odp':
      return {
        src: microsoftOdp,
        alt: 'Microsoft PowerPoint file',
        extension: 'png',
      };
    case 'ods':
      return {
        src: microsoftOds,
        alt: 'Microsoft Excel file',
        extension: 'png',
      };
    case 'odt':
      return {
        src: microsoftOdt,
        alt: 'Microsoft Word file',
        extension: 'png',
      };
    case 'potx':
      return {
        src: microsoftPotx,
        alt: 'Microsoft PowerPoint template file',
        extension: 'svg',
      };
    case 'pot':
      return {
        src: microsoftPot,
        alt: 'Microsoft PowerPoint template file',
        extension: 'png',
      };
    case 'potm':
      return {
        src: microsoftPotm,
        alt: 'Microsoft PowerPoint macro-enabled template file',
        extension: 'png',
      };
    case 'pps':
      return {
        src: microsoftPps,
        alt: 'Microsoft PowerPoint slideshow file',
        extension: 'png',
      };
    case 'ppsx':
      return {
        src: microsoftPpsx,
        alt: 'Microsoft PowerPoint slideshow file',
        extension: 'svg',
      };
    case 'ppsm':
      return {
        src: microsoftPpsm,
        alt: 'Microsoft PowerPoint macro-enabled slideshow file',
        extension: 'png',
      };
    case 'ppt':
      return {
        src: microsoftPpt,
        alt: 'Microsoft PowerPoint file',
        extension: 'png',
      };
    case 'pptx':
      return {
        src: microsoftPptx,
        alt: 'Microsoft PowerPoint file',
        extension: 'svg',
      };
    case 'pptm':
      return {
        src: microsoftPptm,
        alt: 'Microsoft PowerPoint macro-enabled file',
        extension: 'png',
      };
    case 'vsdx':
      return {
        src: microsoftVsdx,
        alt: 'Microsoft Visio file',
        extension: 'svg',
      };
    case 'vssx':
      return {
        src: microsoftVssx,
        alt: 'Microsoft Visio stencil file',
        extension: 'svg',
      };
    case 'vstx':
      return {
        src: microsoftVstx,
        alt: 'Microsoft Visio template file',
        extension: 'svg',
      };
    case 'xls':
      return {
        src: microsoftXls,
        alt: 'Microsoft Excel file',
        extension: 'png',
      };
    case 'xlsx':
      return {
        src: microsoftXlsx,
        alt: 'Microsoft Excel file',
        extension: 'svg',
      };
    case 'xlsm':
      return {
        src: microsoftXlsm,
        alt: 'Microsoft Excel macro-enabled file',
        extension: 'svg',
      };
    case 'xlsb':
      return {
        src: microsoftXlsb,
        alt: 'Microsoft Excel binary file',
        extension: 'png',
      };
    case 'xltx':
      return {
        src: microsoftXltx,
        alt: 'Microsoft Excel template file',
        extension: 'svg',
      };
    case 'rtf':
    case 'pages':
      return {
        src: pageWhiteWord,
        alt: 'Word file',
        extension: 'png',
      };
    case 'numbers':
    case 'csv':
      return {
        src: microsoftCsv,
        alt: 'CSV file',
        extension: 'png',
      };
    case 'keynote':
      return {
        src: pageWhitePowerpoint,
        alt: 'PowerPoint file',
        extension: 'png',
      };
    case 'pdf':
      return {
        src: pageWhiteAcrobat,
        alt: 'PDF file',
        extension: 'png',
      };
    case 'txt':
    case 'nfo':
      return {
        src: pageWhiteText,
        alt: 'Text file',
        extension: 'png',
      };
    case 'jpeg':
    case 'jpg':
    case 'gif':
    case 'png':
    case 'bmp':
      return {
        src: pageWhitePicture,
        alt: 'Picture file',
        extension: 'png',
      };
    case 'mp3':
    case 'wav':
    case 'ogg':
    case 'oga':
      return {
        src: pageWhiteSound,
        alt: 'Sound file',
        extension: 'png',
      };
    case 'avi':
    case 'mp4':
    case 'mkv':
    case 'mpg':
    case 'mpeg':
    case 'ogv':
      return {
        src: pageWhiteFilm,
        alt: 'Film file',
        extension: 'png',
      };
    case 'zip':
    case 'tar':
    case 'gz':
    case 'rar':
    case 'ace':
      return {
        src: pageWhiteCompressed,
        alt: 'Compressed file',
        extension: 'png',
      };
    default:
      return {
        src: pageWhite,
        alt: 'File',
        extension: 'png',
      };
  }
};
